// extracted by mini-css-extract-plugin
module.exports = {"priceCardContainer":"priceCard_priceCardContainer__2XMrF"};